export const ALIGN_MAPPING = {
  "left": "start",
  "center": "center",
  "right": "end",
}

export const DEF_SIDE_CONTEINT_CONF = {
  content: {
    heading: {
      group: "basic",
    },
    text: {
      group: "basic",
    },
    image: {
      group: "basic",
    },
    divider: {
      group: "basic",
    },
    html: {
      group: "basic",
    },
    button: {
      group: "basic",
    },
    // countdown: {
    //   group: "basic",
    // },
    // coupon:{
    //   group: "basic"
    // },
    "form-text": {
      group: "form",
    },
    "form-email": {
      group: "form",
    },
    "form-date": {
      group: "form",
    },
    "form-number": {
      group: "form",
    },
    "form-url": {
      group: "form",
    },
    "form-terms": {
      group: "form",
    },
    "form-textarea": {
      group: "form",
    },
    "form-phone": {
      group: "form",
    },
    "form-option": {
      group: "form",
    },
    "form-radio-grid": {
      group: "form",
    },
    "form-multi-option": {
      group: "form",
    },
    "form-dropdown": {
      group: "form",
    },
    "form-rating": {
      group: "form",
    },
    "form-submit-button": {
      group: "form",
    },
    "form-thankyou": {
      group: "form",
    },
  },
  layout: {},
  setting: {},
  seo: {},
};

export const DEF_FONTS = [
  {
    label: "Arial",
    value: "arial",
  },
  {
    label: "Raleway",
    value: "'Raleway', sans-serif",
    url: "https://fonts.googleapis.com/css2?family=Raleway&display=swap",
  },
  {
    label: "Noto Sans KR",
    value: "'Noto Sans KR', sans-serif",
    url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR&display=swap",
  },
  {
    label: "Malgun Gothic",
    value: "Malgun Gothic",
  },
  {
    label: "Calibri",
    value: "Calibri",
  },
  {
    label: "Corbel",
    value: "corbel",
  },
  {
    label: "PingFang SC",
    value: "PingFangSC-Regular",
  },
  {
    label: "宋體",
    value: "SimSun",
  },
  {
    label: "黑體",
    value: "SimHei",
  },
  {
    label: "微軟雅黑",
    value: "Microsoft YaHei",
  },
  {
    label: "微軟正黑體 ",
    value: "Microsoft JhengHei",
  },
  {
    label: "楷體",
    value: "KaiTi",
  },
  {
    label: "新宋體",
    value: "NSimSun",
  },
  {
    label: "仿宋",
    value: "FangSong",
  },
  {
    label: "新細明體",
    value: "PMingLiU",
  },
  {
    label: "細明體",
    value: "MingLiU",
  },
  {
    label: "華文黑體",
    value: "STHeiti",
  },
  {
    label: "華文楷體",
    value: "STKaiti",
  },
  {
    label: "華文宋體",
    value: "STSong",
  },
  {
    label: "華文仿宋",
    value: "STFangsong",
  },
  {
    label: "華文中宋",
    value: "STZhongsong",
  },
  {
    label: "華文琥珀",
    value: "STHupo",
  },
  {
    label: "華文新魏",
    value: "STXinwei",
  },
  {
    label: "華文隸書",
    value: "STLiti",
  },
  {
    label: "華文行楷",
    value: "STXingkai",
  },
  {
    label: "冬青黑體",
    value: "Hiragino Sans GB",
  },
  {
    label: "蘭亭黑-繁",
    value: "Lantinghei TC",
  },
  {
    label: "蘭亭黑-簡",
    value: "Lantinghei SC",
  },
  {
    label: "翩翩體-繁",
    value: "Hanzipen TC",
  },
  {
    label: "翩翩體-簡",
    value: "Hanzipen SC",
  },
  {
    label: "手札體-繁",
    value: "Hannotate TC",
  },
  {
    label: "手札體-簡",
    value: "Hannotate SC",
  },
  {
    label: "宋體-繁",
    value: "Songti TC",
  },
  {
    label: "宋體-簡",
    value: "Songti SC",
  },
  {
    label: "娃娃體-繁",
    value: "Wawati TC",
  },
  {
    label: "娃娃體-簡",
    value: "Wawati SC",
  },
  {
    label: "魏碑-繁",
    value: "Weibei TC",
  },
  {
    label: "魏碑-簡",
    value: "Weibei SC",
  },
  {
    label: "行楷-繁",
    value: "Xingkai TC",
  },
  {
    label: "行楷-簡",
    value: "Xingkai SC",
  },
  {
    label: "雅痞-繁",
    value: "Yapi TC",
  },
  {
    label: "雅痞-簡",
    value: "Yapi SC",
  },
  {
    label: "圓體-繁",
    value: "Yuanti TC",
  },
  {
    label: "圓體-簡",
    value: "Yuanti SC",
  },
];

export const BORDER_OPTIONS = [
  {
    label: "Line",
    value: "solid",
  },
  {
    label: "Dash",
    value: "dashed",
  },
  {
    label: "Dotted",
    value: "dotted",
  },
];


export const DEFAULT_FORM_STYLE = {
  formLabelColor: {r: 0, g: 0, b: 0, a: 1},
  formTextColor: {r: 0, g: 0, b: 0, a: 1},
  formPlaceholderColor: {r: 155, g: 155, b: 155, a: 1},
  formErrorColor: {r: 208, g: 2, b: 27, a: 1},
  formBorderColor: {r: 0, g: 0, b: 0, a: 1},
  formBorderWidth: 1,
  formBorderStyle: "solid",
  formBorderRadius: 3,
}
